export var CONTAINER_CLASS = 'g2-crosshair';
export var CROSSHAIR_LINE = CONTAINER_CLASS + "-line";
export var CROSSHAIR_TEXT = CONTAINER_CLASS + "-text";
//# sourceMappingURL=css-const.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/component/esm/crosshair/css-const.js
// module id = null
// module chunks = 